import { render } from "./third_question.vue?vue&type=template&id=47a95b82&scoped=true"
import script from "./third_question.vue?vue&type=script&lang=js"
export * from "./third_question.vue?vue&type=script&lang=js"

import "./third_question.vue?vue&type=style&index=0&id=47a95b82&scoped=true&lang=css"

import exportComponent from "/Users/matsushitamasaya/webex/setouchi-webapp2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a95b82"]])

export default __exports__